import { render, staticRenderFns } from "./SaleTypeEditGeneralPrintAfterSend.vue?vue&type=template&id=714969d7"
import script from "./SaleTypeEditGeneralPrintAfterSend.vue?vue&type=script&lang=ts"
export * from "./SaleTypeEditGeneralPrintAfterSend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('714969d7')) {
      api.createRecord('714969d7', component.options)
    } else {
      api.reload('714969d7', component.options)
    }
    module.hot.accept("./SaleTypeEditGeneralPrintAfterSend.vue?vue&type=template&id=714969d7", function () {
      api.rerender('714969d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleTypeEditGeneralPrintAfterSend.vue"
export default component.exports